module.exports = __webpack_public_path__ + "static/media/templates-circle.e4ac3c29.svg";